import { memo } from "react";
import Button from "@mui/material/Button";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { TableToolbar, TableToolbarProps } from "ui/widgets/Table";
import { selectIsExportUsersLoading } from "features/users/selectors";
import useUser from "features/auth/useUser";
import { useResource } from "ui/widgets/Resource";
import { isAdmin } from "features/auth/helpers";

const UsersToolbar = ({ onExport }: Pick<TableToolbarProps, 'onExport'>) => {
    const { onOpen } = useResource();
    const { user } = useUser();

    const add = () => (
        <>
            {isAdmin(`${user?.roleName}`) && (
                <Button
                    size='small'
                    startIcon={<GroupAddIcon />}
                    onClick={() => onOpen()}
                    data-test-id='users.button.addUser'
                >
                    Add User
                </Button>
            )}
        </>
    );

    return (
        <TableToolbar
            onExport={onExport}
            selectIsExportLoading={selectIsExportUsersLoading}
            add={add}
        />
    );
};

export default memo(UsersToolbar);
